import React from 'react';

import { onGetLocalFromUtc } from '@utils/Util';

const MaterialRoadmapView = ({ supplierList = [], onClose, showCloseButton = false }) => {
	return (
		<div className="material-roadmap-component">
			<div className="d-flex justify-content-between align-items-center mb-3">
				<h3 className="semibold-14">
					MATERIAL ROADMAP
					<span className="regular-12 gray_dark_02 weight-400 ml-1">
						(from where we can source this material)
					</span>
				</h3>
				{showCloseButton && (
					<img src={`${process.env.PUBLIC_URL}/icons/close.svg`} alt="close" onClick={onClose} />
				)}
			</div>

			<div className="w-100 scroll-x-label">
				<table className="table with-border no-hover height-sm material-roadmap-table">
					<thead>
						<tr>
							<th>SL</th>
							<th>Supplier</th>
							<th>Lead time</th>
							<th>MOQ</th>
							<th> MOQ Unit</th>
							<th className="text-right">Unit Price: $</th>
							<th>Last updated</th>
							<th>Remarks</th>
						</tr>
					</thead>
					<tbody>
						{supplierList.map((item, index) => (
							<tr key={index}>
								<td>{index + 1}</td>
								<td className="supplier-column">
									<p>{item?.name}</p>
								</td>
								<td className="lead-time-column">
									<p>{item?.leadTimeInDays}</p>
								</td>
								<td className="qty-column">{item?.moq}</td>
								<td className="unit-column">{item?.pricePerUnit}</td>
								<td className="price-column">{item?.price}</td>

								<td className="date-column">
									{onGetLocalFromUtc(
										item?.lastPriceModifiedAt,
										'DD MMM, YYYY [at] hh:mm A'
									)}
								</td>
								<td className="remarks-column">{item?.description}</td>
							</tr>
						))}
					</tbody>
				</table>
			</div>
		</div>
	);
};

export default MaterialRoadmapView;
